// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormTipInput_container__Ke0YN{
    display: inline-block;
}
.FormTipInput_label__RO2NE{
    margin-bottom: 10px;
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
}
.FormTipInput_description__fd3yr{
    color: #1F363D;
    font-size: 12px;
}
.FormTipInput_sliderContainer__x-FbV{
    margin-top: 60px;
}
.FormTipInput_slider__WtFbp{
    width: 100%;
    margin-top: 30px;
}
.FormTipInput_sliderTrack__9reFH{
    top: 0;
    bottom: 0;
    height: 8px;
    background-color: #40798C;
    border-radius: 999px;
}
.FormTipInput_sliderThumbContainer__TQPhz{
    position: relative;
}
.FormTipInput_sliderThumbContainer__TQPhz:focus-visible{
    outline: none !important;
}
.FormTipInput_sliderThumbBubble__KfHAn{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -55px;
    left: -23px;
    width: 60px;
    padding: 8px 0;
    color: #40798C;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    border: 1px solid #1F363D1A;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.FormTipInput_sliderThumb__FY-FC{
    position: relative;
    top: -14px;
    height: 16px;
    width: 16px;
    background-color: #FFFFFF;
    border: 1px solid #40798C66;
    border-radius: 50%;
    cursor: pointer;
}
.FormTipInput_customTipContainer__Od\\+Tq{
    display: flex;
    justify-content: center;
    margin-top: 20px;
    cursor: pointer;
}
.FormTipInput_suitcaseDollarSign__CmF1d{
    position: relative;
    top: 0.5px;
    height: 16px;
    width: 20px;
    margin-right: 8px;
}
.FormTipInput_customTipText__3O4I\\+{
    color: #40798C;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.FormTipInput_inputContainer__lz\\+0E{
    position: relative;
    margin-top: 15px;
}
.FormTipInput_input__M4ab-{
    height: 16px;
    width: calc(100% - 36px);
    padding: 20px 12px 20px 24px;
    color: #1F363D;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 500px;
}
.FormTipInput_input__M4ab-::placeholder{
    color: #1F363D80;
}
.FormTipInput_input__M4ab-:focus{
    border: 1px solid #40798C;
    outline: none;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.FormTipInput_error__1376m{
    border: 1px solid #EB443F;
}
.FormTipInput_dollarGreen__oot3M{
    position: absolute;
    top: 20px;
    right: 30px;
    height: 18px;
    width: 10px;
}
.FormTipInput_cancelText__8qB7I{
    margin-top: 15px;
    text-align: center;
    color: #40798C;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/form/FormTipInput.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,MAAM;IACN,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,cAAc;IACd,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,cAAc;IACd,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,kCAAkC;AACtC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,eAAe;AACnB","sourcesContent":[".container{\n    display: inline-block;\n}\n.label{\n    margin-bottom: 10px;\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n}\n.description{\n    color: #1F363D;\n    font-size: 12px;\n}\n.sliderContainer{\n    margin-top: 60px;\n}\n.slider{\n    width: 100%;\n    margin-top: 30px;\n}\n.sliderTrack{\n    top: 0;\n    bottom: 0;\n    height: 8px;\n    background-color: #40798C;\n    border-radius: 999px;\n}\n.sliderThumbContainer{\n    position: relative;\n}\n.sliderThumbContainer:focus-visible{\n    outline: none !important;\n}\n.sliderThumbBubble{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: -55px;\n    left: -23px;\n    width: 60px;\n    padding: 8px 0;\n    color: #40798C;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    border: 1px solid #1F363D1A;\n    border-radius: 10px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.sliderThumb{\n    position: relative;\n    top: -14px;\n    height: 16px;\n    width: 16px;\n    background-color: #FFFFFF;\n    border: 1px solid #40798C66;\n    border-radius: 50%;\n    cursor: pointer;\n}\n.customTipContainer{\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    cursor: pointer;\n}\n.suitcaseDollarSign{\n    position: relative;\n    top: 0.5px;\n    height: 16px;\n    width: 20px;\n    margin-right: 8px;\n}\n.customTipText{\n    color: #40798C;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.inputContainer{\n    position: relative;\n    margin-top: 15px;\n}\n.input{\n    height: 16px;\n    width: calc(100% - 36px);\n    padding: 20px 12px 20px 24px;\n    color: #1F363D;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 500px;\n}\n.input::placeholder{\n    color: #1F363D80;\n}\n.input:focus{\n    border: 1px solid #40798C;\n    outline: none;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.error{\n    border: 1px solid #EB443F;\n}\n.dollarGreen{\n    position: absolute;\n    top: 20px;\n    right: 30px;\n    height: 18px;\n    width: 10px;\n}\n.cancelText{\n    margin-top: 15px;\n    text-align: center;\n    color: #40798C;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FormTipInput_container__Ke0YN`,
	"label": `FormTipInput_label__RO2NE`,
	"description": `FormTipInput_description__fd3yr`,
	"sliderContainer": `FormTipInput_sliderContainer__x-FbV`,
	"slider": `FormTipInput_slider__WtFbp`,
	"sliderTrack": `FormTipInput_sliderTrack__9reFH`,
	"sliderThumbContainer": `FormTipInput_sliderThumbContainer__TQPhz`,
	"sliderThumbBubble": `FormTipInput_sliderThumbBubble__KfHAn`,
	"sliderThumb": `FormTipInput_sliderThumb__FY-FC`,
	"customTipContainer": `FormTipInput_customTipContainer__Od+Tq`,
	"suitcaseDollarSign": `FormTipInput_suitcaseDollarSign__CmF1d`,
	"customTipText": `FormTipInput_customTipText__3O4I+`,
	"inputContainer": `FormTipInput_inputContainer__lz+0E`,
	"input": `FormTipInput_input__M4ab-`,
	"error": `FormTipInput_error__1376m`,
	"dollarGreen": `FormTipInput_dollarGreen__oot3M`,
	"cancelText": `FormTipInput_cancelText__8qB7I`
};
export default ___CSS_LOADER_EXPORT___;
